<template>
  <div>
    <template-list :document-type="1" :value.sync="editedDelegation" v-if="editedDelegation != null" />
    <v-container>
      <h1>{{ $t("delegation.form.newSettlement") }}</h1>

      <div class="mt-3 elevation-12 grey lighten-4">
        <v-stepper non-linear value="1" v-model="stepper">
          <v-stepper-header style="">
            <v-stepper-step :rules="[() => generalErrors.length === 0]" editable :step="1">
              {{ $t("delegation.form.generalData") }}
              <small v-if="generalErrors.length > 0">{{ $t("global.fieldsToCheck") }} {{ generalErrors.length }} </small>
            </v-stepper-step>
            <v-divider />
            <v-stepper-step :rules="[() => transportErrors.length === 0]" editable :step="2">
              {{ $t("delegation.form.transportData") }}
              <small v-if="transportErrors.length > 0">{{ $t("global.fieldsToCheck") }} {{ countTransportErrors }} </small>
            </v-stepper-step>
            <v-divider />
            <v-stepper-step :rules="[() => countryErrors.length === 0]" editable :step="3">
              {{ $t("delegation.form.accommodationData") }}
              <small v-if="countryErrors.length > 0">{{ $t("global.fieldsToCheck") }} {{ countCountryErrors }}</small>
            </v-stepper-step>
            <v-divider />
            <v-stepper-step :rules="[() => summaryErrors.length === 0]" editable :step="4">
              {{ $t("delegation.form.summaryAttachment") }}
              <small v-if="summaryErrors.length > 0">{{ $t("global.fieldsToCheck") }} {{ summaryErrors.length }} </small>
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content :step="1">
              <general :delegationErrors="errorsDelegation" v-if="editedDelegation != null && errorsDelegation != null" />
            </v-stepper-content>
            <v-stepper-content :step="2">
              <transport :delegation.sync="editedDelegation" :delegationErrors="errorsDelegation" v-if="editedDelegation != null && errorsDelegation != null" />
            </v-stepper-content>
            <v-stepper-content :step="3">
              <country :delegation.sync="editedDelegation" :delegationErrors="errorsDelegation" v-if="editedDelegation != null && errorsDelegation != null" />
            </v-stepper-content>
            <v-stepper-content :step="4">
              <attachment
                :delegation.sync="editedDelegation"
                :delegationErrors="errorsDelegation"
                v-if="editedDelegation != null && errorsDelegation != null"
              />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <v-card>
          <v-card-actions>
            <v-spacer />
            <v-btn v-if="stepper === 1" @click.native="cancel()" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
            <v-btn v-if="stepper > 1" @click.native="stepper--" color="blue darken-1" text>{{ $t("global.back") }}</v-btn>
            <v-btn v-if="stepper < 4" @click.native="stepper++" color="blue darken-1" text>{{ $t("global.next") }}</v-btn>
            <v-btn
              v-if="stepper === 4 && $store.state.Delegation.readonly !== true"
              @click.native="save()"
              :disabled="$store.getters['Ajax/loading']"
              color="blue darken-1"
              text
              >{{ $t("global.save") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<script>
import TransportTypes from "../../staticData/TransportTypes";
import PaymentTypes from "../../staticData/PaymentTypes";
import Currency from "../../staticData/CurrencyTypes";
import General from "./DelegationFormStandard/General.vue";
import Transport from "./DelegationFormStandard/Transport.vue";
import Country from "./DelegationFormStandard/Country.vue";
import Attachment from "./DelegationFormStandard/Attachment.vue";
import TemplateList from "../TemplateList";

const _ = require("lodash");

export default {
  name: "DelegationForm",
  components: {
    TemplateList,
    Transport,
    Country,
    Attachment,
    General
  },
  data: () => ({
    formControls: {
      settlementDatetimePicker: false,
      startTimePicker: false,
      startDatePicker: false,
      endTimePicker: false,
      endDatePicker: false,
      customRules: false,
      delegationAdvances: false
    },
    stepper: 1,
    transport_types: TransportTypes,
    payment_types: PaymentTypes,
    currency: Currency,
    formTitle: "",
    users: [],
    delegation_tasks: [],
    snackbar: false
  }),

  watch: {
    editedDelegation: {
      handler(val) {
        this.$store.commit("Delegation/setEditedDelegation", val);
        this.serverValidation();
      },
      deep: true
    },
    datePickerPickedDate: function(oldModel, newModel) {
      if (newModel === true) {
        this.formControls.startTimePicker = true;
      }
    },
    advancePanel: function(value) {
      if (value) {
        if (this.editedDelegation.advances.length === 0) {
          // add new advance on panel expand
          this.addDelegationAdvance();
        }
      } else {
        // clean empty advances
        for (let index in this.editedDelegation.advances) {
          let advance = this.editedDelegation.advances[index];
          if (advance.id === null && (advance.amount == null || advance.amount.length < 1) && advance.payment_type == null && advance.payment_date == null) {
            this.removeAdvance(advance);
          }
        }
      }
    }
  },

  computed: {
    defaultSettlementDate: function() {
      if (this.editedDelegationOrder.end_date) {
        let date = new Date(this.editedDelegationOrder.end_date.substring(0, 10));
        date.setDate(date.getDate() + 14);
        return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
      }
      return null;
    },
    advancePanel: function() {
      return this.formControls.delegationAdvances;
    },
    datePickerPickedDate: function() {
      return this.formControls.startDatePicker;
    },
    editedDelegation: {
      get() {
        return this.$store.state.Delegation.delegationEdited; //["Delegation/delegationEdited"];
      },
      set(val) {
        this.$store.commit("Delegation/setEditedDelegation", val);
      }
    },
    errorsDelegation: function() {
      return this.$store.getters["Delegation/delegationErrors"];
    },
    generalErrors() {
      if (
        this.$store.getters["Delegation/delegationErrors"] === null ||
        typeof this.$store.getters["Delegation/delegationErrors"].generalErrors === "undefined"
      )
        return [];
      return this.$store.getters["Delegation/delegationErrors"].generalErrors;
    },
    transportErrors() {
      if (
        this.$store.getters["Delegation/delegationErrors"] === null ||
        typeof this.$store.getters["Delegation/delegationErrors"].transportErrors === "undefined"
      )
        return [];
      return this.$store.getters["Delegation/delegationErrors"].transportErrors;
    },
    countCountryErrors() {
      return this.countErrors(this.$store.getters["Delegation/delegationErrors"].country);
    },
    countryErrors() {
      if (
        this.$store.getters["Delegation/delegationErrors"] === null ||
        typeof this.$store.getters["Delegation/delegationErrors"].countryErrors === "undefined"
      )
        return [];
      return this.$store.getters["Delegation/delegationErrors"].countryErrors;
    },
    summaryErrors() {
      if (
        this.$store.getters["Delegation/delegationErrors"] === null ||
        typeof this.$store.getters["Delegation/delegationErrors"].summaryErrors === "undefined"
      )
        return [];
      return this.$store.getters["Delegation/delegationErrors"].summaryErrors;
    },
    countTransportErrors() {
      let delegationOtherTransport = [];
      for (let delegationOtherIndex in this.editedDelegation.other.filter(v => v.type === "transport")) {
        delegationOtherTransport.push(this.$store.getters["Delegation/delegationErrors"].other[delegationOtherIndex]);
      }
      return this.countErrors(this.$store.getters["Delegation/delegationErrors"].transport) + this.countErrors(delegationOtherTransport);
    }
  },
  methods: {
    countErrors(item) {
      let count = 0;
      for (let property in item) {
        if (typeof item[property] === "string") {
          return 1;
        }
        if (item[property] !== null && typeof item[property] === "object") {
          count += this.countErrors(item[property]);
        }
      }
      return count;
    },
    isFormChanged() {
      return JSON.stringify(this.$store.state.Delegation.delegationEdited) !== JSON.stringify(this.$store.state.Delegation.nonChangedDelegation);
    },
    save() {
      if (this.$store.state.Delegation.readonly !== true) {
        if (!this.isValidModel()) {
          this.$store.dispatch("snackbarPush", {
            text: this.$t("delegation.form.cantSave"),
            color: "error"
          });
          return false;
        }

        if (!this.$store.state.Delegation.delegationCalculation.isValidTransportLimit) {
          this.$store
            .dispatch("confirmDialog", {
              content: this.$t("delegation.form.transportOverLimit.content"),
              title: this.$t("delegation.form.transportOverLimit.title")
            })
            .then(() => {
              let promise = this.$store.dispatch("Delegation/saveChanges", this.editedDelegation);
              promise
                .then(() => {
                  this.$router.push("/delegation");
                })
                .catch(err => {
                  console.log(err);
                  this.$store.dispatch("alertDialog", {
                    content: this.$t("global.error.generalError.content") + err.data.message,
                    title: this.$t("global.error.generalError.title")
                  });
                });
            })
            .catch(() => {});
          return false;
        }

        let promise = this.$store.dispatch("Delegation/saveChanges", this.editedDelegation);
        promise
          .then(() => {
            this.$router.push("/delegation");
          })
          .catch(err => {
            console.log(err);
            this.$store.dispatch("alertDialog", {
              content: this.$t("global.error.generalError.content") + err.data.message,
              title: this.$t("global.error.generalError.title")
            });
          });
      }
    },
    cancel() {
      this.$router.push("/delegation");
      this.$store.dispatch("Delegation/cancelChanges");
    },
    isValidModel() {
      if (this.generalErrors.length !== 0) return false;
      if (this.transportErrors.length !== 0) return false;
      if (this.countryErrors.length !== 0) return false;
      if (this.summaryErrors.length !== 0) return false;
      return true;
    },
    serverValidation: _.debounce(function() {
      this.$store.dispatch("Delegation/validateDelegation");
    }, 300),
    locationSearch: _.debounce(function(searchText, object) {
      object.loading = true;
      const result = [{ value: "1", text: "Jakis" }];
      this.axios({
        url: "location/search",
        data: { q: searchText },
        method: "POST"
      }).then(resp => {
        for (let index in resp.data) {
          object.$data.items.push({
            value: resp.data[index].id,
            text: resp.data[index].text
          });
        }
        object.loading = false;
      });
      return result;
    }, 300),
    beforeRouteLeave(from, to, next) {
      if (from.fullPath === "/logout" || this.$store.state.Delegation.readonly === true) {
        next();
      } else if (this.isFormChanged()) {
        let result = this.$store.dispatch("confirmDialog", {
          content: this.$t("global.saveBeforeExit.content"),
          title: this.$t("global.saveBeforeExit.title"),
          customButtons: [
            { text: this.$t("global.cancel"), value: "cancel" },
            { text: this.$t("global.no"), value: "no" },
            { text: this.$t("global.yes"), color: "primary", value: "yes" }
          ]
        });
        result.then(chosen => {
          if (chosen === "cancel") {
            next(false);
          } else if (chosen === "no") {
            next();
          } else if (chosen === "yes") {
            this.save();
          }
        });
      } else {
        next();
      }
    }
  },
  created() {
    this.$store.commit("Delegation/downloadDelegationAvailableUsers");
    if (typeof this.$route.params.id !== "undefined") {
      this.$store.dispatch("Delegation/editDelegation", this.$route.params.id);
    } else if (typeof this.$route.params.orderId !== "undefined") {
      this.$store.dispatch("Delegation/newDelegationFromOrder", this.$route.params.orderId);
    } else {
      let userProperty = this.$store.getters["userProperties"];
      if (userProperty.system_settings.delegation_order_type === 3) {
        let result = this.$store.dispatch("alertDialog", {
          content: this.$t("delegation.form.errorCanNotCreateMultipleBasedOnOrder.content"),
          title: this.$t("delegation.form.errorCanNotCreateMultipleBasedOnOrder.title")
        });
        result.then(() => {
          this.$router.push("/delegation");
        });
      }
      this.$store.dispatch("Delegation/newDelegation");
    }
    //this.$store.dispatch('Visual/setHalfBackground');
  },
  mounted() {
    this.$store.dispatch("Visual/setHalfBackground");
  },
  beforeDestroy() {
    this.$store.dispatch("Visual/setWhiteBackground");
  }
};
</script>

<style scoped></style>
